export default {
    user: {
        create: {
            title: "Nowy użytkownik",
            model: {
                email: {
                    label: "E-mail",
                    placeholder: "Wypełnij adres e-mail"
                },
                name: {
                    label: "Nazwa",
                    placeholder: "Wpisz nazwę"
                },
                country: {
                    label: "Kraj",
                    placeholder: "Wypełnij kraj"
                },
                approval_manager_email: {
                    label: "E-mail menedżera",
                    placeholder: "Wypełnij adres e-mail menedżera",
                    errors: {
                        different: "Adres e-mail menedżera ds. zatwierdzania musi być inny niż adres e-mail użytkownika"
                    }
                }
            },
            cta: {
                submit: {
                    text: "Składać",
                    processing: "Przedkładający"
                },
                cancel: {
                    text: "Anulować"
                }
            }
        },
        country: {
            title: "Kraj użytkownika",
            header: "{email} nie ma wybranego kraju. Proszę wybrać jego kraj.",
            model: {
                country: {
                    label: "Kraj",
                    placeholder: "Wypełnij kraj"
                }
            },
            cta: {
                submit: {
                    text: "Składać",
                    processing: "Przedkładający"
                },
                cancel: {
                    text: "Anulować"
                }
            }
        }
    }
}